<template>
    <div class="col backgroundForm">
        
        <div class="col col-md-10 offset-md-1">
            <h3 clas="col" align="center">Registro Trafico de Embarcacion Nacional</h3>
            <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <a class="nav-item nav-link disabled" :class="[is_active_step_one ? 'active':'']" id="nav-init-traffic" data-toggle="tab" href="#nav-init" role="tab" aria-controls="nav-home" aria-selected="true">1. Datos</a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_two ? 'active':'']" id="nav-second-traffic" data-toggle="tab" href="#nav-second" role="tab" aria-controls="nav-profile" aria-selected="false">2. Detalle </a>
                    <a class="nav-item nav-link disabled" :class="[is_active_step_tree ? 'active':'']" id="nav-tirdh-traffic" data-toggle="tab" href="#nav-tirdh" role="tab" aria-controls="nav-profile" aria-selected="false">3. Resumen </a>
                </div>
            </nav>
            
            
            <div class="tab-content" id="nav-tabContent">

                <div class="tab-pane fade" :class="[ is_active_step_one ? 'show active':'']" id="nav-init" role="tabpanel" aria-labelledby="nav-home-tab">
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="nombre_embarcacion" class="badge badge-primary">Nombre de la Embarcacion</label>                    
                            <input type="text" class="form-control" disabled v-model="boatLocal.name_boat" id="nombre_embarcacion" placeholder="Nombre Embarcacion" autocomplete="off">
                        </div>
                        
                        <div class="form-group col col-md-6">
                            <label for="matricula" class="badge badge-primary">Matricula de la Embarcacion</label>
                            <input type="text" class="form-control" disabled v-model="boatLocal.enrollment" name="matricula" placeholder="Matricula Embarcacion" autocomplete="off">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="bandera_embarcacion" class="badge badge-primary">Bandera de la Embarcacion</label>
                            <input type="text" class="form-control" disabled value="Bolivia" name="matricula" placeholder="Bandera" autocomplete="off">
                        </div>

                        <div class="form-group col col-md-6">
                            <label for="propulsion" class="badge badge-primary">Propulsion</label>
                            <input type="text" class="form-control" name="propulsion" disabled v-model="boatLocal.detail_propulsion" placeholder="Propulsion" autocomplete="off">
                        </div>                
                    </div>
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="trb" class="badge badge-primary">TRB</label>
                            <input type="text" v-model="boatLocal.trb" readonly class="form-control" name="trb" placeholder="TRB" autocomplete="off">
                        </div>
                        <div class="form-group col col-md-6">
                            <label for="trb" class="badge badge-primary">TRN</label>
                            <input type="text" v-model="boatLocal.trn" readonly class="form-control" name="trn" placeholder="TRN" autocomplete="off" >
                        </div>
                    </div>

                    <button class="btn btn-outline-warning col col-md-4 offset-md-4" @click="fNext">Siguiente</button>
                </div> 
                <!-- fin del primer tab -->

                <div class="tab-pane fade" :class="[ is_active_step_two ? 'show active':'']" id="nav-second" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="form-row">
                        <div class="form-group col col-md-6">
                            <label for="tipo_navegacion" class="badge badge-primary">Despacho de Nave</label>
                            <select class="form-control" v-model="navegacion" name="tipo_navegacion" @change="callNavDet">
                                <option v-for="navigate in navegaciones" :value="navigate.id" :key="navigate.id">{{ navigate.detail }} </option>
                            </select>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="state_navigation_sub">
                        <div class="form-row">
                            <div class="form-group col col-md-6">
                                <label for="navegacion_detalle" class="badge badge-info">- Tipo de Navegacion</label>
                                <select class="form-control" v-model="navegacion_sub" name="navegacion_detalle" @change="calculateForm">
                                    <option v-for="n_detail in navegaciones_sub" :key="n_detail.id" :value="n_detail" >{{ n_detail.detail }}</option>
                                </select>
                            </div>
                                    
                            <div class="form-group col col-md-6">
                                <label for="fecha_despacho" class="badge badge-info">- Fecha de {{ type_navigate }}</label>
                                <input type="date" class="form-control" v-model="date_office" name="fecha_despacho" placeholder="Fecha" autocomplete="off">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col col-md-6">
                                <label for="puerto_origen" class="badge badge-info">- Puerto de origen</label>
                                <input type="text" class="form-control" name="puerto_origen" placeholder="Puerto Origen" autocomplete="off">
                            </div>

                            <div class="form-group col col-md-6">
                                <label for="puerto_destino" class="badge badge-info">- Puerto de destino</label>
                                <input type="text" class="form-control" name="puerto_destino" placeholder="Puerto Destino" autocomplete="off">
                            </div>
                        </div>
                    </div>
                    </transition>
                    <div class="row">
                        
                    </div>
                    
                    <div class="form-row">
                        <div class="col col-md-8">
                            <label for="trb" class="badge badge-primary">Carga Efectiva</label><br>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" v-model="c_efectiva_load" @change="viewForm">
                                <label class="form-check-label" for="inlineCheckbox1">Carga</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" v-model="c_efectiva_passenger" @change="viewForm">
                                <label class="form-check-label" for="inlineCheckbox2">Pasajeros</label>
                            </div>
                        </div>
                    </div>
                    <transition name="fade" mode="out-in">
                    <div v-if="passenger_view">
                        <h6><span class="badge badge-info">- Cantidad Pasajeros</span></h6>
                        <div class="row">
                        <div class="col col-md-6">
                            <h6><span class="badge badge-success">Nacionales</span></h6>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                </div>
                                <input type="number" v-model="national_men" @change="calcLoadCash" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                </div>
                                <input type="number" class="form-control" @change="calcLoadCash" v-model="national_women" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                            </div>
                        </div>

                        <div class="col col-md-6">
                            <h6><span class="badge badge-success">Extranjeros</span></h6>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-default">Hombre</span>
                                </div>
                                <input type="number" v-model="foreign_men" @change="calcLoadCash" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-default">Mujer</span>
                                </div>
                                <input type="number" v-model="foreign_women" @change="calcLoadCash" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                            </div>
                        </div>
                        </div>
                    </div>
                    </transition>
                    
                    <transition name="fade" mode="out-in">
                        <div v-if="load_cash_view">
                        <div class="form-row">
                            <div class="form-group col col-md-6">
                                <label for="type_ship" class="badge badge-info">- Tipo de nave</label>
                                <select class="form-control" v-model="type_ship" name="type_ship" @change="callService">
                                    <option v-for="type in type_ships" :key="type.id" :value="type.id">{{ type.detail }}</option>
                                </select>
                            </div>
                            <div class="form-group col col-md-6">
                                <label for="actividad" class="badge badge-info">- Tipo de servicio</label>
                                <select class="form-control" v-model="actividad" name="actividad" @change="calculateForm">
                                    <option v-for="activity in actividades_nave" :key="activity.id" :value="activity">{{ activity.detail }} - {{ activity.factor }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col col-md-8">                                
                                <div class="row">                                        
                                    <div class="col col-md-6">
                                        <label for="load_cash_kilo" class="badge badge-info">Kilos</label>
                                        <input type="number" v-model="load_cash_kilo" @keyup="calcKiloTonelada" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">    
                                    </div>
                                    <div class="col col-md-6">
                                        <label for="load_cash_tonelada" class="badge badge-info">Toneladas</label>
                                        <input type="number" v-model="load_cash_tonelada" @keyup="calcToneladaKilo" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col col-md-4">
                                <label for="load_cash_litro" class="badge badge-info">- Peso en Litros</label>
                                <input type="number" v-model="load_cash_litro" class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default">
                            </div>
                        </div>
                        </div>
                    </transition>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">Anterior</button>
                    <button class="btn btn-outline-warning col col-md-4" @click="fNext">Siguiente</button>
                </div>

                <div class="tab-pane fade" :class="[ is_active_step_tree ? 'show active':'']" id="nav-tirdh" role="tabpanel" aria-labelledby="nav-home-tab">
                        
                        <div class="form-row">
                            <div class="form-group col col-md-4">
                                <label for="actividad" class="badge badge-success">Nombre Embarcacion</label>
                                <p class="text-uppercase">{{ boatLocal.name_boat }}</p>
                            </div>
                            <div class="form-group col col-md-3">
                                <label for="load_cash_kilo" class="badge badge-success">TRB</label>
                                <p class="text-uppercase">{{ boatLocal.trb }}</p>
                            </div>
                            <div class="form-group col col-md-3">
                                <label for="load_cash_litro" class="badge badge-success">Propulsion</label>
                                <p class="text-uppercase">{{ boatLocal.detail_propulsion }}</p>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col col-md-4">
                                <label for="actividad" class="badge badge-success">Tipo Despache</label>
                                <p class="text-uppercase" v-if="type_navigate">{{ type_navigate }}</p>
                                <p class="text-uppercase" v-else>--Sin Datos--</p>
                            </div>

                            <div class="form-group col col-md-4">
                                <label for="actividad" class="badge badge-success">Servicio</label>
                                <p class="text-uppercase" v-if="navegacion_sub">{{ navegacion_sub.detail }}</p>
                                <p class="text-uppercase" v-else>-- Sin datos --</p>
                            </div>
                        </div>

                    <div class="form-group">
                        <label for="total_importe" class="badge badge-danger">Importe Aprox. en Bs.</label>
                        <input type="text" class="form-control" name="total_importe" v-model="total_form" placeholder="TOTAL IMPORTE" disabled >
                    </div>
                    <button class="btn btn-outline-danger col col-md-4 offset-md-2" @click="fBack">Anterior</button>

                    <button class="btn btn-outline-primary col col-md-4" >Autorizar</button>    
                </div> 

            </div>                
            
        </div>
    </div>
</template>
<script>
// import { EventBus } from '@/helpers/EventBus';
import axios from 'axios';
const qs = require('qs');

export default {
    name:'boat-register',
    data(){
        return {
            is_active_step_one:true,
            is_active_step_two:false,
            is_active_step_tree:false,            
            type_navigate:null,
            navegacion:null,
            navegaciones:[],
            navegacion_sub:null,//
            state_navigation_sub:false,
            navegaciones_sub:[],
            actividad:null,//
            actividades_nave:[],
            ufv:null,
            c_efectiva_passenger:false,
            c_efectiva_load:false,
            passenger_view:false,
            load_cash_view:false,
            passenger:null,//
            load_cash_kilo:0,//
            load_cash_tonelada:0,
            load_cash_litro:null,//
            load_cash:null,//
            load_cashs:[],
            total_form:null,
            factor_trb:null,
            national_men:null,
            national_women:null,
            foreign_men:null,
            foreign_women:null,
            date_office:null,
            type_ship:null,
            type_ships:[],
            cut:0
        }
    },
    computed:{
        boatLocal(){
            return this.$store.getters.getBoat
        }
    },
    mounted(){
        this.verifyBoat(),
        this.callNavigate(),
        // this.callService(),
        this.callUfv(),
        // this.callNavDet(),
        this.getToday(),
        this.callTypesShip()
    },
    methods:{
        callTypesShip(){
            this.type_services=null;
            axios.get('ships/servicionave')
            .then(res => {                
                this.type_ships=res.data
            })
        },
        verifyBoat(){
            
            if(this.boatLocal.length <= 0){
                console.log('el bote no contiene registros')
                toastr.warning('Debe realizar previamente la busqueda', 'Advertencia')
                this.$router.push('search')
            }
        },
        getToday(){
            let  today = new Date();
            let m = today.getMonth() + 1;
            let mes = (m < 10) ? '0' + m : m;
            let d = today.getDate();
            let dia= (d < 10) ? '0'+d : d;
            this.date_office=today.getFullYear()+'-'+mes+'-'+dia;
            
        },
        sendRegisterBoat(){
            // console.log(this.boatLocal.name_boat)
            console.log("enviando al servidor")
        },
        sendRegister() {
            if(this.total_form && this.matricula && this.bandera){
                form.reset();
            }else{
                toastr.warning('Verifique que los campos esten completos ','Advertencia');
            }
        },
        callNavigate(){
            axios.get('navigation')
            .then(res => {                
                this.navegaciones=res.data
            })
        },
        findValue(id){
            // for(let i=0; i<this.navegaciones.length; i++){
            //     this.navegaciones
            // }
            for(let key in this.navegaciones){
                if(this.navegaciones[key].id === id){
                    this.type_navigate=this.navegaciones[key].detail.toLowerCase();
                    
                }
            }
        },
        callPropulsion(){
            axios.post('submenu',qs.stringify({parent:4}))
            .then(res => {
                
                this.propulsiones=res.data
            })
        },
        callService(){
            axios.post('submenu',qs.stringify({parent:7}))
            .then(res => {                
                this.actividades_nave=res.data
            })
        },
        callUfv(){
            axios.get('ufv')
            .then(res => {
                this.ufv=res.data[0].value;
            })
        },
        callNavDet(){
            
                this.findValue(this.navegacion);
                axios.post('submenu', qs.stringify({parent:this.navegacion}))
                .then(res => {                
                    this.navegaciones_sub=res.data
                    this.state_navigation_sub=true
                })
            
        },
        calcLoadCash(){
            let vep=0;
            let vecl=0;
            let veck=0;
            let vect=0;
            if(this.national_men || this.national_women){
                console.log(this.national_men)
                vep += this.national_men ? parseInt(this.national_men) : 0;
                vep += this.national_women ? parseInt(this.national_women) : 0;
            }
            if(this.foreign_men && this.foreign_women){
                vep += this.foreign_men ? parseInt(this.foreign_men) : 0;
                vep += this.foreign_women ? parseInt(this.foreign_women) : 0;
            }

            if(this.load_cash_kilo || this.load_cash_litro || this.load_cash_tonelada){
                veck += this.load_cash_kilo ? parseInt(this.load_cash_kilo) : 0;
                vect += this.load_cash_tonelada ? parseInt(this.load_cash_tonelada) : 0;;
                vecl += this.load_cash_litro ? parseInt(this.load_cash_litro) : 0;
            }

            // console.log('el valor de kilo y litro es '+vecl)

        },
        viewForm(){
            if(this.c_efectiva_passenger){
                this.passenger_view=true;
            }else{
                this.passenger_view=false;
            }

            if(this.c_efectiva_load){
                this.load_cash_view=true;
            }else{
                this.load_cash_view=false;
            }
        },
        calculateForm(){
            
            let result=0;
            this.calcCUT();
            
            // FIXME:verificar que el factor de carga se sume o multiplique hablar
            if(this.navegacion_sub && this.actividad){
                // result = (1+this.navegacion_sub.factor*this.propulsion.factor*actividad_pasajeros*this.factor_trb)*this.ufv;
                result= (this.cut*this.boatLocal.trb*(this.navegacion_sub.factor*this.boatLocal.factor_propulsion*this.actividad.factor)+1)*this.ufv;
                this.total_form=result.toFixed(1);
                // toastr.success(''+this.total_form+'','Importe Aprox.')
            }else{
                console.log('aun faltan datos por confirmar');
                // toastr.error('Aun falta llenar campos', 'Alerta');
            }
                // toastr.success(''+this.total_form+'','Importe Aprox.')
        },
        fNext(){
            switch(true){
                case this.is_active_step_one:
                    this.is_active_step_one=false;
                    this.is_active_step_two=true;
                break;

                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_tree=true;
                break;
            }
        },
        fBack(){            
            switch(true){
                case this.is_active_step_two:
                    this.is_active_step_two=false;
                    this.is_active_step_one=true;
                break;

                case this.is_active_step_tree:
                    this.is_active_step_tree=false;
                    this.is_active_step_two=true;
                break;
            }
        },
        callService(){
            axios.get('submenus/'+this.type_ship)
            .then(res => {                
                this.actividades_nave=res.data
            })
        },
        calcToneladaKilo(){
            this.load_cash_kilo=this.load_cash_tonelada*1000;
        },
        calcKiloTonelada(){
            this.load_cash_tonelada=this.load_cash_kilo/1000;
        },
        calcCUT(){
            let fact_a=0.1;
            let fact_b=2;
            let fact_c=1.8;
            this.cut=fact_c/(1+fact_a*Math.pow(this.boatLocal.trb, (1/fact_b) ))/2.3;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/cotizacion/boatRegister.vue